import moment from 'moment';

export const processes = [
  {
    module_date: new Date(),
    machine_id: null,
    breakdown_id: null,
    down_time: null,
    cum_down_time:null,
    per_cum_down_time:null,
    // reason: '',
    // action_plan: '',
    // attended_by: '',
    // remarks: '',
    // analysis_down_time: '',
  },
];
